import { DataBean } from "../DataBean";


export class TaxSchemeContext extends DataBean {

    public async getTaxSchemeContextCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxSchemeContextCatalog_Number", [arg]);
    }

}